import { library, dom, IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { faPlus as faPlusLight, faMinus, faCheck as faCheckLight } from "@fortawesome/pro-light-svg-icons";
import { faCheck as faCheckRegular, faAngleLeft, faAngleRight, faStar as faStarRegular, faPlus as faPlusRegular, faSearch, faCircle as faCircleRegular, faTimes, faAngleUp, faAngleDown, faCaretLeft as faCaretLeftRegular, faCaretRight as faCaretRightRegular } from "@fortawesome/pro-regular-svg-icons";
import { faChevronUp, faChevronDown, faCalendarAlt, faTimesCircle, faChevronLeft, faChevronRight, faCaretUp, faCaretDown, faCircle as faCircleSolid, faCaretLeft as faCaretLeftSolid, faCaretRight as faCaretRightSolid, faSortUp, faSortDown, faSort, faStar as faStarSolid, faRedoAlt, faChevronDoubleUp, faChevronDoubleDown } from "@fortawesome/pro-solid-svg-icons";
import { faTwitter } from "@fortawesome/free-brands-svg-icons";
import { BlockConfigurationObject } from "../interfaces/block-configuration-object.interface";
import { MatchTeam } from "../interfaces/match-team.interface";

export class GeneralService {

	_configurationObject: BlockConfigurationObject;

	terminologyLocaleObjects: Record<string, Record<string, string>>;
	shortSportNames: Record<string, string>;

	/* @ngInject */
	constructor(configurationObject: BlockConfigurationObject) {
		this._configurationObject = configurationObject;
		this.terminologyLocaleObjects = {
			AU: {
				match: "match",
				match_tennis: "match",
				matches: "matches",
				matches_tennis: "matches",
				prematch: "pre-match",
				prematch_tennis: "pre-match",
				fixture: "fixture",
				fixtures: "fixtures",
				value_picks: "value picks",
				prop_picks: "prop picks",
				sidebar_title: "predictor picks",
				h2h: "Head to Head",
				h2h_short: "H2H",
				line: "Line",
				line_nhl: "Line",
				line_mlb: "Line",
				line_short: "Line",
				game_line: "Game Line",
				total: "Total",
				total_short: "Total",
				firstset: "First Set",
				firstset_short: "1st Set",
				shortlist: "Watch List",
				shortlist_adjective: "Watched",
				my_shortlist: "Watch List",
				no_shortlisted: "Start your Watch List by making a free account, then clicking the star on your favourite live or upcoming matches",
				no_live: "There aren’t any live games happening right now",
				bts: "Both Teams to Score",
				bts_short: "BTS",
				bet_button_cta: "Join Now",
				"high-open_short": "High Open",
				"high-open": "Highest Opening Partnership",
				"four-overs_short": "After 4 Overs",
				"four-overs": "Leading team after 4 Overs",
				"first-wicket_short": "First Wicket",
				"first-wicket": "Fall of First Wicket",
				"most-sixes": "Most Sixes",
				"most-sixes_short": "Most Sixes",
			},
			UK: {
				match: "match",
				match_tennis: "match",
				matches: "matches",
				matches_tennis: "matches",
				prematch: "pre-match",
				prematch_tennis: "pre-match",
				fixture: "fixture",
				fixtures: "fixtures",
				value_picks: "value picks",
				prop_picks: "prop picks",
				sidebar_title: "predictor picks",
				h2h: "Head to Head",
				h2h_short: "Match Odds",
				line: "Handicap",
				line_nhl: "Handicap",
				line_mlb: "Handicap",
				line_short: "Handicap",
				game_line: "Game Line",
				total: "Over/Under",
				total_short: "Over/Under",
				firstset: "First Set",
				firstset_short: "1st Set",
				shortlist: "Watch List",
				shortlist_adjective: "Watched",
				my_shortlist: "Watch List",
				no_shortlisted: "Start your Watch List by making a free account, then clicking the star on your favourite live or upcoming matches",
				no_live: "There aren’t any live games happening right now",
				bts: "Both Teams to Score",
				bts_short: "BTTS",
				bet_button_cta: "Join Now",
				"high-open_short": "High Open",
				"high-open": "Highest Opening Partnership",
				"four-overs_short": "After 4 Overs",
				"four-overs": "Leading team after 4 Overs",
				"first-wicket_short": "First Wicket",
				"first-wicket": "Fall of First Wicket",
				"most-sixes": "Most Sixes",
				"most-sixes_short": "Most Sixes",
			},
			US: {
				match: "game",
				match_tennis: "match",
				matches: "games",
				matches_tennis: "matches",
				prematch: "pre-game",
				prematch_tennis: "pre-match",
				fixture: "schedule",
				fixtures: "schedule",
				value_picks: "best bets",
				prop_picks: "best props",
				sidebar_title: "upcoming",
				h2h: "Moneyline",
				h2h_short: "Moneyline",
				line: "Spread",
				line_nhl: "Puck Line",
				line_mlb: "Run Line",
				line_short: "Spread",
				game_line: "Game Spread",
				total: "Over / Under",
				total_short: "O/U",
				firstset: "First Set",
				firstset_short: "1st Set",
				shortlist: "shortlist",
				shortlist_adjective: "shortlisted",
				my_shortlist: "My shortlist",
				no_shortlisted: "No shortlisted games available",
				no_live: "No live games available",
				bts: "Both Teams to Score",
				bts_short: "BTS",
				bet_button_cta: "Bet Now",
				"high-open_short": "High Open",
				"high-open": "Highest Opening Partnership",
				"four-overs_short": "After 4 Overs",
				"four-overs": "Leading team after 4 Overs",
				"first-wicket_short": "First Wicket",
				"first-wicket": "Fall of First Wicket",
				"most-sixes": "Most Sixes",
				"most-sixes_short": "Most Sixes",
			},
			US_Pickswise: {
				match: "game",
				match_tennis: "match",
				matches: "games",
				matches_tennis: "matches",
				prematch: "pre-game",
				prematch_tennis: "pre-match",
				fixture: "schedule",
				fixtures: "schedule",
				value_picks: "quick picks",
				sidebar_title: "predictor picks",
				h2h: "Moneyline",
				h2h_short: "Moneyline",
				line: "Spread",
				line_nhl: "Puck Line",
				line_mlb: "Run Line",
				line_short: "Spread",
				game_line: "Game Spread",
				total: "Over / Under",
				total_short: "O/U",
				firstset: "First Set",
				firstset_short: "1st Set",
				shortlist: "shortlist",
				shortlist_adjective: "shortlisted",
				my_shortlist: "My shortlist",
				no_shortlisted: "No shortlisted games available",
				no_live: "No live games available",
				bts: "Both Teams to Score",
				bts_short: "BTS",
				bet_button_cta: "Join Now",
				"high-open_short": "High Open",
				"high-open": "Highest Opening Partnership",
				"four-overs_short": "After 4 Overs",
				"four-overs": "Leading team after 4 Overs",
				"first-wicket_short": "First Wicket",
				"first-wicket": "Fall of First Wicket",
				"most-sixes": "Most Sixes",
				"most-sixes_short": "Most Sixes",
			}
		};

		this.shortSportNames = {
			"ESP": "La Liga",
			"ALG": "A-League",
			"SRU": "Super Rugby",
			"TRC": "Rugby Championship",
			"TEN": "Tennis",
			"CBB": "College Basketball",
			"CFB": "College Football",
			"EPL": "Premier League",
			"SOO": "Origin",
			"LMX": "Liga MX",
			"EURO": "Euro 2020",
			"SWC": "FIFA World Cup",
		};
	}

	isSoccer(sport: string): boolean {
		return sport && ["EPL", "ESP", "ALG", "MLS", "EURO", "SWC"].includes(sport.toUpperCase());
	}
	
	localeTerm(term: string, modification?: string): string {
		let locale = this._configurationObject.terminologyLocale;
		if (!locale || !Object.keys(this.terminologyLocaleObjects).includes(locale)) {
			locale = "AU";
		}
		let retrievedTerm: string;
		if (Object.keys(this.terminologyLocaleObjects[locale]).includes(term)) {
			retrievedTerm = this.terminologyLocaleObjects[locale][term];
		} else {
			// TODO decide if there's a better way to handle unrecognised messages (throw error, show message in place of term)
			retrievedTerm = term;
		}

		if (modification === "all-caps") {
			return retrievedTerm.toUpperCase();
		} else if (modification === "title-case") {
			return retrievedTerm.replace(/\b\w+/g, s => s.charAt(0).toUpperCase() + s.substr(1).toLowerCase());
		} else {
			return retrievedTerm;
		}
	}

	

	getMatchLink(matchid: string): string {
		if (this._configurationObject.matchLinkFunction) {
			return this._configurationObject.matchLinkFunction(matchid);
		}

		if (this._configurationObject.matchLinkStructure) {
			const interpolated = this._configurationObject.fixtureLinkStructure.replace(/\{M\}/g, matchid.toLowerCase());
			return interpolated;
		}

		return "";
	}

	getFuturesLink(sport: string): string {
		if (this._configurationObject.futuresLinkFunction) {
			return this._configurationObject.futuresLinkFunction(sport);
		}

		return "";
	}

	getFixtureLink(sport: string): string {
		if (sport) {
			if (this._configurationObject.fixtureLinkFunction) {
				return this._configurationObject.fixtureLinkFunction(sport);
			} else if (this._configurationObject.fixtureLinkStructure) {
				const interpolated = this._configurationObject.fixtureLinkStructure.replace(/\{S\}/g, sport.toLowerCase());
				return interpolated;
			}
		}

		return "";
	}

	getValueBetsLink(): string {
		if (this._configurationObject.valueBetsLink) {
			return this._configurationObject.valueBetsLink;
		}

		return "";
	}

	shortenName(firstName: string, surname: string): string {
		return firstName.split(" ").map(s => s[0] + ". ").join("") + surname;
	}

	getShortName(sport: string): string {
		if (sport && Object.keys(this.shortSportNames).includes(sport.toUpperCase())) {
			return this.shortSportNames[sport.toUpperCase()];
		}

		return sport;
	}

	initialiseBlock(): void {
		// Font Awesome icons that are used in blocks
		library.add(faPlusLight, faMinus, faCheckLight, faCheckRegular, faAngleLeft, faAngleRight, faStarRegular,
			faPlusRegular, faSearch, faCircleRegular, faTimes, faChevronUp, faChevronDown, faChevronDoubleUp, faChevronDoubleDown,
			faCalendarAlt, faTimesCircle, faChevronLeft, faChevronRight, faCaretUp, 
			faCaretDown, faCircleSolid, faCaretLeftSolid, faCaretRightSolid, faCaretLeftRegular, faCaretRightRegular,
			faSortUp, faSortDown, faSort, faStarSolid, faAngleUp, faAngleDown, faRedoAlt, faTwitter as IconDefinition);

		dom.watch();

		if (this._configurationObject.linkCallback) {
			document.querySelector("#" + this._configurationObject.targetElementID).addEventListener("click", (event: MouseEvent) => {
				const linkParent = (event.target as Element).closest("a[href]:not([override-callback])");
				if (linkParent !== null
					&& linkParent.getAttribute("target") !== "_blank"
					&& event.button === 0 && !(event.shiftKey || event.altKey || event.metaKey || event.ctrlKey)) {
					event.preventDefault();
					this._configurationObject.linkCallback(linkParent.getAttribute("href"));
				}
			});
		}
	}
	
	hedgedProbString(probNumber: number, decPlaces: number): string {
		// if passed in probability is not a number, return a dash
		if (typeof probNumber !== "number") {
			return "-";
		}

		// if number would get rounded to 100%, but isn't, change to "more than" highest visible number below 100%
		if (parseFloat((probNumber * 100).toFixed(decPlaces)) == 100 && probNumber != 1) {
			return `>99${decPlaces == 0 ? "" : "."}${"9".repeat(decPlaces)}%`;
		}

		// if number would get rounded to 0%, but isn't, change to "more than" lowest visible number above 0%
		if (parseFloat((probNumber * 100).toFixed(decPlaces)) == 0 && probNumber != 0) {
			return `<${decPlaces == 0 ? "1" : ("0." + "0".repeat(decPlaces - 1) + "1")}%`;
		}

		// otherwise, return the number converted to a percentage, to the specified number of decimal places
		return (probNumber * 100).toFixed(decPlaces) + "%";
	}

	teamNameDisplay(sport: string, teamObject: MatchTeam): string {
		if (teamObject) {
			if (this._configurationObject.customTeamDisplayNames && this._configurationObject.customTeamDisplayNames[sport.toUpperCase()]
				&& this._configurationObject.customTeamDisplayNames[sport.toUpperCase()][teamObject.Abv.toUpperCase()]) {
				return this._configurationObject.customTeamDisplayNames[sport.toUpperCase()][teamObject.Abv.toUpperCase()];
			}

			if (this._configurationObject.teamDisplayNameDefault) {
				if (this._configurationObject.teamDisplayNameDefault === "market") {
					if (teamObject.Market) {
						return teamObject.Market;
					}
					if (teamObject.Nickname) {
						return teamObject.Nickname;
					}
					return teamObject.DisplayName;
				} else {
					if (teamObject.Nickname) {
						return teamObject.Nickname;
					}

					return teamObject.DisplayName;
				}
			} else {
				if (teamObject.Nickname) {
					return teamObject.Nickname;
				}

				if (teamObject.Market) {
					return teamObject.Market;
				}

				return teamObject.DisplayName;
				
			}
		}
		
		return "";
	}
}